module.exports = __webpack_public_path__ + "static/media/duplicate-icon.60c86b9b.svg";